// History 모듈 라우트 — AppShell children 으로 주입되어 Content(router-view)에 렌더된다.
export default [
  {
    path: "/history/orders",
    name: "HistoryOrderList",
    component: () => import("./views/Order/OrderList.vue"),
    meta: { title: "기술지원요청확인", perm: "HISTORY_WEB" },
  },
  {
    path: "/history/PastReqList",
    name: "HistoryPastReqList",
    component: () => import("./views/Order/PastReqList.vue"),
    meta: { title: "요청자 과거 기술지원 이력검색", perm: "HISTORY_WEB" },
  },
  {
    path: "/history/SupportList",
    name: "HistorySupportList",
    component: () => import("./views/Order/SupportList.vue"),
    meta: { title: "기술지원 내용 입력(조회)", perm: "HISTORY_WEB" },
  },

  // ── 그리드 셀 클릭으로 이동하는 상세/조회 라우트 (:id 파라미터) ──
  // 요청자 클릭 → 해당 요청자 과거이력
  {
    path: "/history/pastReqList/:id",
    name: "HistoryPastReqListById",
    component: () => import("./views/Order/PastReqList.vue"),
    meta: { title: "요청자 과거 기술지원 이력검색", perm: "HISTORY_WEB" },
  },
  // 기술지원 횟수 클릭 → 해당 요청번호의 지원내역
  {
    path: "/history/supportList/:id",
    name: "HistorySupportListById",
    component: () => import("./views/Order/SupportList.vue"),
    meta: { title: "기술지원 내용 입력(조회)", perm: "HISTORY_WEB" },
  },
  // 제목 클릭 → 기술지원 내용 입력/수정
  {
    path: "/history/supportContent/:id",
    name: "HistorySupportContent",
    component: () => import("./views/Order/SupportContent.vue"),
    meta: { title: "기술지원 내용 입력(입력/수정)", perm: "HISTORY_WEB" },
  },
  // 요청번호 클릭 → 기술지원요청 상세(탭: 설비상세/점검내용/운전조건/부품사양/이력/이력Remote)
  {
    path: "/history/orderDetail/:orderNo",
    name: "HistoryOrderDetail",
    component: () => import("./views/Order/OrderListDetail_Detail.vue"),
    meta: { title: "기술지원요청 상세", perm: "HISTORY_WEB" },
  },
];
